
























import { Component, Prop, Vue } from 'vue-property-decorator';
import PageBanner from '@/components/PageBanner.vue';
import TeamMember from '@/components/TeamMember.vue';
import { getImgUrl } from '../utils/dummy';
import { HOST } from '@/global';

import {
  TimelineMax,
  CSSPlugin,
  CSSRulePlugin,
  ScrollToPlugin,
  Draggable,
  Power4,
  Expo,
  Elastic,
  Bounce,
  onComplete,
  clearProps,
  TweenMax,
  fromTo
} from 'gsap/all';

@Component({
  name: 'team',
  components: {
    TeamMember
  }
})
export default class Team extends Vue {
  @Prop() compData: any;
  HOST: string = HOST;

  public activeTabIdx: number = 0;

  // get activeTab() {
  //   return this.compData.tab[this.activeTabIdx];
  // }
}
